import { useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Package } from '@mint-lib/icons';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@mint-lib/tw-components';

import { useIsReadOnlyUser } from '../../hooks/index.js';
import {
  useImportHubLayoutRouteApi,
  useImportHubPaths,
} from '../../hooks/useImportHubRouteApi.js';
import { useTemplates } from '../../queries/index.js';
import { initialSearchParams } from '../../queries/queryClient.js';
import { Tooltip } from '../atoms/Tooltip.jsx';
import { TemplateSelectionModal } from './TemplateSelectionModal.jsx';

export const ImportButton = () => {
  const { t } = useTranslation('@myn/import-hub');
  const navigate = useImportHubLayoutRouteApi().useNavigate();
  const paths = useImportHubPaths();
  const { data: templates } = useTemplates(initialSearchParams);

  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);

  const isReadOnlyUser = useIsReadOnlyUser();

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button disabled={isReadOnlyUser} data-dd-action-name="Import data">
            <Package className="size-4" />
            {t('Import data')}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="w-(--radix-dropdown-menu-trigger-width)"
        >
          <Tooltip
            asChild
            description={t('No templates yet. Create one by uploading a file.')}
            disabled={Boolean(templates?.items.length)}
            side="left"
            className="w-[250px]"
          >
            <div>
              <DropdownMenuItem
                onClick={() => {
                  setIsTemplateModalOpen(true);
                }}
                disabled={!templates?.items.length}
                data-dd-action-name="Use template"
              >
                {t('Use template')}
              </DropdownMenuItem>
            </div>
          </Tooltip>
          <DropdownMenuItem
            onClick={() => {
              navigate({
                to: paths.importsNew,
              });
            }}
            data-dd-action-name="Create new file"
          >
            {t('Create new file')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      {isTemplateModalOpen && (
        <TemplateSelectionModal
          open
          onClose={() => setIsTemplateModalOpen(false)}
        />
      )}
    </>
  );
};
